import { useLocalStorageState } from 'ahooks';
import {
  Drawer,
  Spin,
  Select,
  Badge,
} from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, {
  useEffect,
  useState,
} from 'react';
import Notification from '@/assets/images/header/notification.react.svg?react';
import IconClose from '@/assets/images/icons/icon-close.react.svg?react';
import { getUserId } from '@/infrastructure/auth';
import { ENV } from '@/infrastructure/env-config';
import { logger } from '@/infrastructure/logger';
import { DATONG_ELEMENT_PARAMS, DATONG_PAGE_EID } from '@/infrastructure/reporter/datong/constant';
import { TopMenuButton } from '@/presentation/layouts/header/button';
import { NoticeList } from '@/presentation/layouts/header/notice/notice-list';
import { useStores } from '@/presentation/store';
import style from './index.module.scss';

export enum TypeEnum {
  descriptionImage = 1,
  content = 2,
}

interface IFeatureImages{
  id: number;
  feature_id: number;
  image_url?: string; // 图片url
  image_description?: string; // 图片描述
  display_order: number; // 排序
  content?: string; // 富文本
  type: TypeEnum; // 类型
}
interface IFeatures {
  id: number;
  release_record_id: number;
  title: string; // 标题
  order_index: number; // 排序
  feature_images_data: IFeatureImages[]; // 图片描述数据
}

export interface IRelease{
  iframe_url?: string;
  id: number;
  title: string; // 标题
  description?: string; // 描述
  publish_date?: string; // 发布日期 ，如果没有则不显示
  force_popup?: boolean; // 是否强制弹出，未配置时默认 false
  date: string; // 标题日期
  features_data: IFeatures[];
}


export const Notice = () => {
  const { productId, pid, loaded } = useStores().ProductStore;
  const userId = getUserId();
  const [messageDrawerVisible, setMessageDrawerVisible] = useState(false);
  const [spining, setSpining] = useState(false);
  const [noticeList, setNoticeList] = useState<IRelease[]>([]);
  const [selectedNotice, setSelectedNotice] = useState<number | undefined>(undefined);
  const [localDate, setLocalDate] = useLocalStorageState<number | undefined>(
    'use-local-storage-pudate-notice-date',
    {
      defaultValue: undefined,
    },
  );
  const getNotice = async () => {
    setSpining(true);
    try {
      const apiList = [`https://api.wuji.qq.com/x/api/wuji_cache/object?appid=${ENV.wujiNoticeUpdateAppId}&schemaid=release&schemakey=${ENV.wujiNoticeUpdateReleaseSchemakey}&size=total`,
        `https://api.wuji.qq.com/x/api/wuji_cache/object?appid=${ENV.wujiNoticeUpdateAppId}&schemaid=features&schemakey=${ENV.wujiNoticeUpdateFeaturesSchemakey}&size=total`,
        `https://api.wuji.qq.com/x/api/wuji_cache/object?appid=${ENV.wujiNoticeUpdateAppId}&schemaid=feature_images&schemakey=${ENV.wujiNoticeUpdateFeatureImagesSchemakey}&size=total`,
      ];
      const resList = await Promise.all(apiList.map(url => axios.get(url, { withCredentials: true })));
      const [release, features, featureImages] = resList;
      const newData: IRelease[] = [];
      release?.data?.data?.filter((item: IRelease) => item.publish_date)?.forEach?.((item: IRelease) => {
        const newFeatures: IFeatures[] = [];
        features?.data?.data?.forEach?.((featuresItem: IFeatures) => {
          newFeatures.push({
            ...featuresItem,
            feature_images_data: featureImages?.data?.data
              ?.filter((featureImagesItem: IFeatureImages) => featureImagesItem?.feature_id === featuresItem.id)
              ?.sort?.((a: IFeatureImages, b: IFeatureImages) => a.display_order - b.display_order) || [],
          });
        });
        newData.push({
          ...item,
          features_data: newFeatures
            ?.filter((newFeaturesItem: IFeatures) => newFeaturesItem?.release_record_id === item?.id)
            ?.sort?.((a, b) => a.order_index - b.order_index) || [],
        });
      });
      const data = [...newData]?.sort?.((
        a: IRelease,
        b: IRelease,
      ) => moment(b.publish_date).unix() - moment(a.publish_date).unix()) || [];
      setNoticeList(data);
      setSelectedNotice(data[0]?.id);
      setSpining(false);
      const latestNotice = data[0];
      // 没有 publish_date 不强制弹出
      if (!latestNotice?.publish_date) {
        return;
      }

      const publishDate = moment(latestNotice.publish_date).unix();
      // 时间过期一个月不强制弹出
      if ((moment().unix() - publishDate) > 2592000) {
        return;
      }
      // force_popup 未配置时默认为 false，即不强制弹出
      if (!latestNotice.force_popup) {
        return;
      }
      if (!localDate || !moment(localDate).isValid()) {
        setLocalDate(publishDate);
        setMessageDrawerVisible(true);
        return;
      }
      if (publishDate > localDate) {
        setMessageDrawerVisible(true);
        setLocalDate(publishDate);
        return;
      }
    } catch (e) {
      logger.error('getMessage:', e);
    }
    setSpining(false);
  };


  useEffect(() => {
    if (productId && pid && loaded) {
      getNotice();
    }
  }, [productId, pid, userId, loaded]);

  return <>
    <div
      className={style.messageCenter}
      dt-eid={DATONG_PAGE_EID.dashboardTopProblem}
      dt-params={`${DATONG_ELEMENT_PARAMS.homeTopBtnName}=消息`}
    >
      <Badge size="small">
        <TopMenuButton onClick={() => setMessageDrawerVisible(true)}>
          <Notification />
          <span>消息中心</span>
        </TopMenuButton>
      </Badge>
    </div>
    <Drawer
      extra={<div onClick={() => setMessageDrawerVisible(false)} className={'px-[2px] py-[2px] rounded-[2px] hover:bg-gray-100 flex items-center cursor-pointer'}><IconClose/></div>}
      closable={false}
      forceRender={true}
      placement="right"
      visible={messageDrawerVisible}
      title={<span className={'text-[#122440] text-[16px] font-medium'}>消息中心</span>}
      width={768}
      onClose={() => setMessageDrawerVisible(false)}
      bodyStyle={{ padding: 20, paddingLeft: 14, paddingRight: 14 }}
    >
      <Spin spinning={spining}>
        <div className={'mb-[10px]'}>
          <Select className={'w-[280px]'}
                  value={selectedNotice}
                  onChange={value => setSelectedNotice(value)}
                  options={noticeList?.map(item => ({ label: item.title, value: item.id }))}/>
        </div>
        <NoticeList
          data={noticeList?.find(item => item.id === selectedNotice)}
        />
      </Spin>
    </Drawer>
  </>;
};
